<nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav bg-sub-nav-2 pl-md-5">
<ul class="navbar-nav">
  <li class="nav-item">
    <a routerLink="./join-requests" routerLinkActive="active" class="nav-link" href="#">
      Join Requests
      <span *ngIf="inboxService.getInboxCounts() && (inboxService.getInboxCounts().association_join_requests > 0)">
        ({{ inboxService.getInboxCounts().association_join_requests }})
      </span>
    </a>
  </li>
</ul>
</nav>

<router-outlet></router-outlet>
